module.exports = __webpack_public_path__ + "static/media/ios-transgender.db5471e5.svg";